import { type FC } from 'react';

import LockOutlined from '@mui/icons-material/LockOutlined';

export interface CenterSlotProps {
  readonly isLocked?: boolean;
}

/**
 * Represents the modular block to the left of the name and description fields.
 * Typically only used for indicating locked levels, but may need drag handle support in the future.
 */
export const CenterSlot: FC<CenterSlotProps> = ({ isLocked }) =>
  isLocked ? <LockOutlined sx={t => ({ color: `${t.palette.action.active} !important` })} /> : null;
